<template>
    <a
        :href="item.href"
        @click.prevent="goToLink(item.href)"
        :style="{ color: player.headingColor }"
        class="relative hidden lg:inline-flex items-center px-3.5 py-2.5 rounded-lg sm:rounded-l-lg text-sm font-medium opacity-100 hover:opacity-80"
    >
        <cUtilsEdit @edit="goToLinkField(item.id, 'linkName')">
            <span>{{ item.name }}</span>
        </cUtilsEdit>
    </a>
</template>

<script>
import { mapState } from "vuex";
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";
import { usePlayerGoTo } from "@/views/tools/player/utils/usePlayerGoTo";
import { useGoToLink } from "@/shared/utils/router/useGoToLink";

export default {
    props: {
        item: Object,
    },
    components: {
        cUtilsEdit,
    },
    setup() {
        const { goToLink } = useGoToLink();
        const { goToLinkField } = usePlayerGoTo();
        return {
            goToLinkField,
            goToLink,
        };
    },
    computed: {
        ...mapState("player/view", ["player"]),
    },
};
</script>
